export default __webpack_public_path__ + "static/media/background.5a431950.png";